/**
 * Injects custom CSS into Shopify Forms embed shadow roots.
 * Finds all divs with [data-forms-id] and styles the inner <shopify-forms-embed> shadow DOM.
 */
(function () {
  const CUSTOM_CSS = `
  *, *::before, *::after {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }

  body, p, span, label, legend, input, select, textarea {
    color: #272725 !important;
  }

  input, select, textarea {
    color: #272725 !important;
    border: 1px solid #0000001A !important;
    border-radius: 10px !important;
  }

  textarea {
    border-radius: 10px !important;
  }

  section[data-sizing="form-wrapper"] {
    max-width: 100% !important;
  }

  section[data-sizing="form-wrapper"] > div:nth-child(2) {
     padding-bottom: 0px !important;
  }

  div:has(textarea)::before {
    background-color: transparent !important;
  }

  input::placeholder, textarea::placeholder {
    color: #272725 !important;
  }

  select option {
    color: #272725 !important;
  }

  button {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border-radius: 10px !important;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out !important;
  }

  button[type="button"] {
    background-color: white !important;
    color: #272725 !important;
    max-height: unset !important;
  }

  button[type="submit"] {
    background-color: #F1684A !important;
    color: white !important;
    padding: 12px 16px 8px 16px !important;
    font-family: var(--font-helvetica-medium) !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: 0 !important;
    vertical-align: middle !important;
    max-width: fit-content !important;
    width: fit-content !important;
    margin: 24px auto 0 auto !important;
    text-transform: uppercase !important;
  }

  button[type="submit"]:hover {
    background-color: #D85A3E !important;
    color: white !important;
    filter: none !important;
  }

  button[type="button"]:hover {
    background-color: rgba(0, 0, 0, 0.05) !important;
    color: #272725 !important;
  }

h2[class^="_textHeading"]  {
   color: var(--color-primary-orange) !important;
   font-family: var(--font-oswald-medium) !important;
   font-weight: 500 !important;
   font-size: 24px !important;
   line-height: 32px !important;
   margin-bottom: 24px !important;
  }

  form[class^="_formFieldset"] {
         gap: 8px !important;
  }

  form[class^="_formFieldset"] > div:first-of-type {
       display: none !important;
  }

    form[class^="_formFieldset"] input,
    form[class^="_formFieldset"] textarea,
    form[class^="_formFieldset"] input[value],
    form[class^="_formFieldset"] textarea[value] {
      box-shadow: none !important;
      border: 1px solid rgba(0, 0, 0, 0.20) !important;
      padding: 11px 16px !important;
      font-family: var(--font-helvetica-roman) !important;
      font: normal 400 16px/24px var(--font-helvetica-roman) !important;
      font-size: 16px !important;
      line-height: 24px !important;
      letter-spacing: 0.01px !important;
    }

    form[class^="_formFieldset"] input::placeholder,
    form[class^="_formFieldset"] textarea::placeholder {
      color: #272725 !important;
      font: normal 400 16px/24px var(--font-helvetica-roman) !important;
      letter-spacing: 0.01px !important;
      line-height: 24px !important;
      font-size: 16px !important;
    }


    form[class^="_formFieldset"] textarea:active + label,
    form[class^="_formFieldset"] textarea:focus + label,
    form[class^="_formFieldset"] textarea:active ~ label,
    form[class^="_formFieldset"] textarea:focus ~ label,
    form[class^="_formFieldset"] textarea.has-value + label,
    form[class^="_formFieldset"] textarea.has-value ~ label  {
      display: none !important;
    }

    button[aria-controls="country-selector-dropdown"] {
          border: 1px solid rgba(0, 0, 0, 0.20) !important;
          box-shadow: none !important;
    }

    button[aria-controls="country-selector-dropdown"] {
    padding: 13px 16px !important;
    }

    form[class^="_formFieldset"] label {
      top: 25px !important;
      transform: translateY(-50%) !important;
      font-family: var(--font-helvetica-roman) !important;
      color: #272725 !important;
      letter-spacing: 0.0192px !important;
      line-height: 24px !important;
            font: normal 400 16px/24px var(--font-helvetica-roman) !important;
    }     

    form[class^="_formFieldset"] input:focus-visible,
    form[class^="_formFieldset"] textarea:focus-visible {
      box-shadow: none !important;
      border: 1px solid #F1684A !important;
    }
      
form[class^="_formFieldset"] input.has-value + label,
form[class^="_formFieldset"] textarea.has-value + label,
form[class^="_formFieldset"] label:has(+ input.has-value),
form[class^="_formFieldset"] label:has(+ textarea.has-value) {
  display: none !important;
}

div[class*="_withError"] input,
div[class*="_withError"] textarea,
  button[class*="_selectorError"]
 {
  box-shadow: none !important;
  border: 1px solid var(--form-error-color) !important;
}

div[class*="_withError"] input:focus-visible,
div[class*="_withError"] textarea:focus-visible,
button[class*="_selectorError"]:focus-visible {
  box-shadow: none !important;
  border: 1px solid var(--form-error-color) !important;
}


output[class*="_formError"]  {
 font: normal 400 14px/20px var(--font-helvetica-roman) !important;
}

@media only screen and (max-width: 768px) {

div[data-testid="app-router"] {
 display: flex !important;
}

#form-container-ref {
width: 100% !important;
max-width: 100% !important;
}

form[class^="_formFieldset"] input,
 form[class^="_formFieldset"] textarea , 
form[class^="_formFieldset"] label {
  font-size: 14px !important;
  line-height: 20px !important;
  font: normal 400 14px/20px var(--font-helvetica-roman) !important;
}

form[class^="_formFieldset"] input, 
form[class^="_formFieldset"] textarea {
padding: 13px 16px !important;
}

form[class^="_formFieldset"] label {
top: 16px !important;
transform: none !important;
}

form[class^="_formFieldset"] div[class*="_selectContainer"] p[class*="_textBody"],
form[class^="_formFieldset"] fieldset legend, 
form[class^="_formFieldset"] div[class*="_formFileInput"] p[class*="_textBody"] {
  font: normal 700 14px/20px var(--font-helvetica-roman) !important;
}

form[class^="_formFieldset"] fieldset[class*="_checkboxFieldSet"] label[class*="_checkboxField"] span, form[class^="_formFieldset"] label[class*="_radioField"] span {
     font: normal 400 14px / 20px var(--font-helvetica-roman), "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

form[class^="_formFieldset"] div[class*="_formFileInput"] p[class*="_formFileInputButton"] {
  font: normal 500 14px/20px var(--font-helvetica-medium), "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

button[type="submit"] {
    font-size: 14px !important;
    line-height: 20px !important;
}

}

fieldset legend,
div[class*="_formFileInput"] p[class*="_textBody"] {
  font: normal 700 16px/24px var(--font-helvetica-roman), "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  color: #272725 !important;
  letter-spacing: 0 !important;
  padding-bottom: 8px !important;
  margin-bottom: 8px !important;
}


div[class*="_selectContainer"] p[class*="_textBody"] {
  font: normal 700 16px/24px var(--font-helvetica-roman), "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  color: #272725 !important;
  letter-spacing: 0 !important;
  padding-bottom: 0px !important;
  margin-bottom: 8px !important;
}

form[class^="_formFieldset"] label[class*="_checkboxField"],
form[class^="_formFieldset"] label[class*="_radioField"] {
position: relative !important;
top: auto !important;
transform: none !important;
display: flex !important;
align-items: center !important;
gap: 8px !important;
}

form[class^="_formFieldset"] label[class*="_checkboxField"] span,
form[class^="_formFieldset"] label[class*="_radioField"] span  {
    font: normal 400 16px / 24px var(--font-helvetica-roman), "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    color: #272725 !important;
    letter-spacing: 0 !important;
    padding-top: 3px !important;
}

form[class^="_formFieldset"] label[class*="_checkboxField"] div,
form[class^="_formFieldset"] label[class*="_radioField"] div {
   width: 20px !important;
   height: 20px !important;
   cursor: pointer !important;
}

form[class^="_formFieldset"] label[class*="_checkboxField"] input,
form[class^="_formFieldset"] label[class*="_radioField"] input {
   width: 20px !important;
   height: 20px !important;
   cursor: pointer !important;
}


form[class^="_formFieldset"] label[class*="_checkboxField"] input:focus-visible,
form[class^="_formFieldset"] label[class*="_radioField"] input:focus-visible,
form[class^="_formFieldset"] label[class*="_checkboxField"] div:focus-visible,
form[class^="_formFieldset"] label[class*="_radioField"] div:focus-visible {
   outline: none !important;
}

form[class^="_formFieldset"] input[type="radio"],
form[class^="_formFieldset"] input[type="checkbox"] {
 accent-color: #F1684A !important;
}

div[class*="_formFileInput"] output {
margin-top: 8px !important;
}

div[class*="_formFieldContainer"],
fieldset,
div[class*="_selectContainer"] {
margin-bottom: 8px !important;
}

div[class*="_formFieldContainer"]:has(input[aria-invalid="true"]),
div[class*="_formFieldContainer"]:has(textarea[class*="_invalid"]) {
margin-bottom: 0px !important;
}

fieldset[class*="_checkboxFieldSet"],
fieldset[class*="_radioFieldSet"] {
margin-bottom: 5px !important;
}


fieldset[class*="_checkboxFieldSet"] div[class*="_verticalLayout"],
fieldset[class*="_radioFieldSet"] div[class*="_verticalLayout"] {
gap: 8px !important;
}

div[class*="_formFileInput"] button[type="button"],
div[class*="_formFileInput"] button[type="button"]:hover {
background: rgba(220, 214, 202, 0.21) !important;
color: #272725 !important;
border: 1px solid #F1684A !important;
padding: 30px 0 !important;
}

div[class*="_formFileInput"] button[type="button"][aria-label="Clear file"] {
  display: flex;
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
}

div[class*="_formFileInput"] p[class*="_formFileInputButton"] {
background: #F1684A !important;
color: white !important;
font: normal 500 16px/24px var(--font-helvetica-medium), "Helvetica Neue", Helvetica, Arial, sans-serif !important;
padding: 12px 16px 8px 16px !important;
border-radius: 10px !important;
}

div[class*="_formFileInput"] p[class*="_formFileInputButton"]:hover {
background: #D85A3E !important;
color: white !important;
}

div[class*="_formFileInput"] {
margin-top: 3px !important;
margin-bottom: 5px !important;
}

div[class*="_formDisclaimer"] p {
  font: normal 400 14px/20px var(--font-helvetica-roman) !important;
  color: #272725 !important;
  letter-spacing: 0 !important;
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
}


.inline-section-form form[class^="_formFieldset"] button[type="submit"] {
margin-top: 6px !important;
}

`.trim();

  const ensureOurStyleIsLast = (root) => {
    let style = root.querySelector('style[data-shopify-forms-embed-custom]');
    if (!style) return;
    if (style.nextElementSibling) {
      style.remove();
      root.appendChild(style);
    }
  };

  const toggleHasValue = (el) => {
    const hasContent = el.value.trim().length > 0;
    el.classList.toggle('has-value', hasContent);
  };

  const attachLabelHideListeners = (root) => {
    if (root._formsEmbedLabelListenersAttached) return;
    root.addEventListener('input', (e) => {
      if (e.target.matches('input:not([type="submit"]):not([type="button"]), textarea')) toggleHasValue(e.target);
    });
    root.addEventListener('change', (e) => {
      if (e.target.matches('input:not([type="submit"]):not([type="button"]), textarea')) toggleHasValue(e.target);
    });
    root._formsEmbedLabelListenersAttached = true;
  };

  const syncHasValueOnForm = (root) => {
    const form = root.querySelector('form[class^="_formFieldset"]');
    if (form) {
      form.querySelectorAll('input:not([type="submit"]):not([type="button"]), textarea').forEach(toggleHasValue);
    }
  };

  const injectStylesIntoShadowRoot = (host) => {
    if (!host.shadowRoot) return false;
    let root = host.shadowRoot;
    let style = root.querySelector('style[data-shopify-forms-embed-custom]');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute('data-shopify-forms-embed-custom', '');
      root.appendChild(style);
    }
    style.textContent = CUSTOM_CSS;
    ensureOurStyleIsLast(root);
    attachLabelHideListeners(root);
    syncHasValueOnForm(root);
    if (!root._formsEmbedStyleObserver) {
      root._formsEmbedStyleObserver = new MutationObserver(() => {
        ensureOurStyleIsLast(root);
        syncHasValueOnForm(root);
      });
      root._formsEmbedStyleObserver.observe(root, { childList: true, subtree: true });
    }
    return true;
  };

  const processContainer = (container) => {
    let embed = container.querySelector('shopify-forms-embed');
    if (!embed) return false;
    return injectStylesIntoShadowRoot(embed);
  };

  const run = () => {
    let containers = document.querySelectorAll('div[data-forms-id]');
    containers.forEach((container) => processContainer(container));
  };

  const observe = () => {
    run();
    let blocks = document.querySelectorAll('.shopify-block.shopify-app-block');
    blocks.forEach((block) => {
      let observer = new MutationObserver(() => run());
      observer.observe(block, { childList: true, subtree: true });
    });
    setTimeout(run, 500);
    setTimeout(run, 1500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
